<ng-container rtBlock="sc-card-carousel">
    <ng-content select="[slot=head]" />

    <div
        rtElem="viewport"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()"
        (focusin)="onFocusIn($event)"
        (focusout)="onFocusOut()">
        <div #track rtElem="track">
            @for (item of loopItems(); track $index) {
                <div rtElem="slide" [attr.inert]="$index >= items().length ? '' : null">
                    <ng-container [ngTemplateOutlet]="itemTemplate()" [ngTemplateOutletContext]="{ $implicit: item }" />
                </div>
            }
        </div>
        <button
            rtElem="arrow"
            rtButton
            icon="arrow-left"
            size="lg"
            type="button"
            [rtMod]="{ prev: true }"
            [attr.aria-label]="prevAriaLabel()"
            (click)="scroll(-1)"></button>
        <button
            rtElem="arrow"
            rtButton
            icon="arrow-right"
            size="lg"
            type="button"
            [rtMod]="{ next: true }"
            [attr.aria-label]="nextAriaLabel()"
            (click)="scroll(1)"></button>
    </div>
</ng-container>
